// =============================================================
//  Easter Egg Hunt — agilitegear.com
//  Drop this file and load it via theme.liquid (defer is fine).
// =============================================================

const EASTER_EGG_CONFIG = {
  previewKey: "",        // "" = visible to everyone - localStorage.setItem("agiliteEaster", 1)
  rememberClicked: false,              // true = hide egg for this browser once clicked
  enableAnnouncementOverride: true,    // true = Easter messages replace the announcement bar while hunt is live or just ended today
  eggImageUrl: "https://cdn.shopify.com/s/files/1/0526/4001/files/MTC_RGG_WEBP_60x60_dfe6cc5e-7e39-4a26-95b4-2c1c635d9e96.webp?v=1774371071",

  // =============================================================
  //  All user-facing text — edit freely
  //  In announcementActive: {count} = number of eggs, {s} = "" or "s"
  // =============================================================
  text: {
    announcementActive:  "🥚 Easter egg hunt is live — {count} egg{s} hidden right now!",
    announcementEnded:   "🐣 Egg hunt is over for today! The egg was at",
    celebrationTitle:    "YOU FOUND IT! 🥚",
    celebrationSubtitle: "Go to checkout QUICK to get the plate carrier!",
    celebrationDismiss:  "Tap anywhere to continue",
    toastSuccess:        "🥚 You found it! A surprise has been added to your cart.",
    toastSoldOut:        "Someone was faster! This egg is gone. 🐣",
    toastError:          "Something went wrong — please try again.",
    eggAriaLabel:        "Hidden easter egg — click me!",
  },

  eggs: [
    {
      name: "egg1-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/scorpion-patch",                 // exact pathname match
        top: "8%",
        left: "50%"
      }
    },
    {
      name: "egg2-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe-2",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/buddystrap-injured-person-carrier",                 // exact pathname match
        top: "30%",
        left: "80%"
      }
    },
    
  ]
};
const EASTER_EGG_DAY2_CONFIG = {
  previewKey: "",        // "" = visible to everyone - localStorage.setItem("agiliteEaster", 1)
  rememberClicked: false,              // true = hide egg for this browser once clicked
  enableAnnouncementOverride: true,    // true = Easter messages replace the announcement bar while hunt is live or just ended today
  eggImageUrl: "https://cdn.shopify.com/s/files/1/0526/4001/files/MTC_RGG_WEBP_60x60_dfe6cc5e-7e39-4a26-95b4-2c1c635d9e96.webp?v=1774371071",

  // =============================================================
  //  All user-facing text — edit freely
  //  In announcementActive: {count} = number of eggs, {s} = "" or "s"
  // =============================================================
  text: {
    announcementActive:  "🥚 Easter egg hunt is live — {count} egg{s} hidden right now!",
    announcementEnded:   "🐣 Egg hunt is over for today! The egg was at",
    celebrationTitle:    "YOU FOUND IT! 🥚",
    celebrationSubtitle: "Go to checkout QUICK to get the plate carrier!",
    celebrationDismiss:  "Tap anywhere to continue",
    toastSuccess:        "🥚 You found it! A surprise has been added to your cart.",
    toastSoldOut:        "Someone was faster! This egg is gone. 🐣",
    toastError:          "Something went wrong — please try again.",
    eggAriaLabel:        "Hidden easter egg — click me!",
  },

  eggs: [
    {
      name: "egg1-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/general-purpose-pouch-small",                 // exact pathname match
        top: "8%",
        left: "50%"
      }
    },
    {
      name: "egg2-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe-2",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/grenade-pouch",                 // exact pathname match
        top: "30%",
        left: "80%"
      }
    },
    
  ]
};
const EASTER_EGGs_CONFIG = {
  previewKey: "",        // "" = visible to everyone - localStorage.setItem("agiliteEaster", 1)
  rememberClicked: false,              // true = hide egg for this browser once clicked
  enableAnnouncementOverride: true,    // true = Easter messages replace the announcement bar while hunt is live or just ended today
  eggImageUrl: "https://cdn.shopify.com/s/files/1/0526/4001/files/MTC_RGG_WEBP_60x60_dfe6cc5e-7e39-4a26-95b4-2c1c635d9e96.webp?v=1774371071",

  // =============================================================
  //  All user-facing text — edit freely
  //  In announcementActive: {count} = number of eggs, {s} = "" or "s"
  // =============================================================
  text: {
    announcementActive:  "🥚 Easter egg hunt is live — {count} egg{s} hidden right now!",
    announcementEnded:   "🐣 Egg hunt is over for today! The egg was at",
    celebrationTitle:    "YOU FOUND IT! 🥚",
    celebrationSubtitle: "Go to checkout QUICK to get the plate carrier!",
    celebrationDismiss:  "Tap anywhere to continue",
    toastSuccess:        "🥚 You found it! A surprise has been added to your cart.",
    toastSoldOut:        "Someone was faster! This egg is gone. 🐣",
    toastError:          "Something went wrong — please try again.",
    eggAriaLabel:        "Hidden easter egg — click me!",
  },

  eggs: [
    {
      name: "egg1-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/testing-team-11-hat",                 // exact pathname match
        top: "8%",
        left: "50%"
      }
    },
    {
      name: "egg2-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe-2",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/testing-team-5-hat",                 // exact pathname match
        top: "30%",
        left: "80%"
      }
    },
    
  ]
};
const EASTER_EGGS_CONFIG = {
  previewKey: "",        // "" = visible to everyone - localStorage.setItem("agiliteEaster", 1)
  rememberClicked: false,              // true = hide egg for this browser once clicked
  enableAnnouncementOverride: true,    // true = Easter messages replace the announcement bar while hunt is live or just ended today
  eggImageUrl: "https://cdn.shopify.com/s/files/1/0526/4001/files/MTC_RGG_WEBP_60x60_dfe6cc5e-7e39-4a26-95b4-2c1c635d9e96.webp?v=1774371071",

  // =============================================================
  //  All user-facing text — edit freely
  //  In announcementActive: {count} = number of eggs, {s} = "" or "s"
  // =============================================================
  text: {
    announcementActive:  "🥚 Easter egg hunt is live — {count} egg{s} hidden right now!",
    announcementEnded:   "🐣 Egg hunt is over for today! The egg was at",
    celebrationTitle:    "YOU FOUND IT! 🥚",
    celebrationSubtitle: "Go to checkout QUICK to get the plate carrier!",
    celebrationDismiss:  "Tap anywhere to continue",
    toastSuccess:        "🥚 You found it! A surprise has been added to your cart.",
    toastSoldOut:        "Someone was faster! This egg is gone. 🐣",
    toastError:          "Something went wrong — please try again.",
    eggAriaLabel:        "Hidden easter egg — click me!",
  },

  eggs: [
    {
      name: "egg1-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/testing-team-2-hat",                 // exact pathname match
        top: "8%",
        left: "50%"
      }
    },
    {
      name: "egg2-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe-2",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/agilite-glove-hanger",                 // exact pathname match
        top: "30%",
        left: "80%"
      }
    },
    
  ]
};
const EASTER_EGG_100_CONFIG = {
  previewKey: "",        // "" = visible to everyone - localStorage.setItem("agiliteEaster", 1)
  rememberClicked: false,              // true = hide egg for this browser once clicked
  enableAnnouncementOverride: true,    // true = Easter messages replace the announcement bar while hunt is live or just ended today
  eggImageUrl: "https://cdn.shopify.com/s/files/1/0526/4001/files/MTC_RGG_WEBP_60x60_dfe6cc5e-7e39-4a26-95b4-2c1c635d9e96.webp?v=1774371071",

  // =============================================================
  //  All user-facing text — edit freely
  //  In announcementActive: {count} = number of eggs, {s} = "" or "s"
  // =============================================================
  text: {
    announcementActive:  "🥚 Easter egg hunt is live — {count} egg{s} hidden right now!",
    announcementEnded:   "🐣 Egg hunt is over for today! The egg was at",
    celebrationTitle:    "YOU FOUND IT! 🥚",
    celebrationSubtitle: "Go to checkout QUICK to get the plate carrier!",
    celebrationDismiss:  "Tap anywhere to continue",
    toastSuccess:        "🥚 You found it! A surprise has been added to your cart.",
    toastSoldOut:        "Someone was faster! This egg is gone. 🐣",
    toastError:          "Something went wrong — please try again.",
    eggAriaLabel:        "Hidden easter egg — click me!",
  },

  eggs: [
    {
      name: "egg1-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/k-zero-bundle",                 // exact pathname match
        top: "8%",
        left: "50%"
      }
    },
    {
      name: "egg2-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe-2",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/reaper-scorpion-patch",                 // exact pathname match
        top: "30%",
        left: "80%"
      }
    },
    
  ]
};
const GOLDEN_EASTER_EGG_CONFIG = {
  previewKey: "",        // "" = visible to everyone - localStorage.setItem("agiliteEaster", 1)
  rememberClicked: false,              // true = hide egg for this browser once clicked
  enableAnnouncementOverride: true,    // true = Easter messages replace the announcement bar while hunt is live or just ended today
  eggImageUrl: "https://cdn.shopify.com/s/files/1/0526/4001/files/MTC_RGG_WEBP_60x60_dfe6cc5e-7e39-4a26-95b4-2c1c635d9e96.webp?v=1774371071",

  // =============================================================
  //  All user-facing text — edit freely
  //  In announcementActive: {count} = number of eggs, {s} = "" or "s"
  // =============================================================
  text: {
    announcementActive:  "🥚 Easter egg hunt is live — {count} egg{s} hidden right now!",
    announcementEnded:   "🐣 Egg hunt is over for today! The egg was at",
    celebrationTitle:    "YOU FOUND IT! 🥚",
    celebrationSubtitle: "Go to checkout QUICK to get the plate carrier!",
    celebrationDismiss:  "Tap anywhere to continue",
    toastSuccess:        "🥚 You found it! A surprise has been added to your cart.",
    toastSoldOut:        "Someone was faster! This egg is gone. 🐣",
    toastError:          "Something went wrong — please try again.",
    eggAriaLabel:        "Hidden easter egg — click me!",
  },

  eggs: [
    {
      name: "egg1-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/trauma-shears",                 // exact pathname match
        top: "8%",
        left: "50%"
      }
    },
    {
      name: "egg2-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe-2",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/agilite-troop-shirt",                 // exact pathname match
        top: "30%",
        left: "80%"
      }
    },
    
  ]
};
const EASTERS_EGG_CONFIG = {
  previewKey: "",        // "" = visible to everyone - localStorage.setItem("agiliteEaster", 1)
  rememberClicked: false,              // true = hide egg for this browser once clicked
  enableAnnouncementOverride: true,    // true = Easter messages replace the announcement bar while hunt is live or just ended today
  eggImageUrl: "https://cdn.shopify.com/s/files/1/0526/4001/files/MTC_RGG_WEBP_60x60_dfe6cc5e-7e39-4a26-95b4-2c1c635d9e96.webp?v=1774371071",

  // =============================================================
  //  All user-facing text — edit freely
  //  In announcementActive: {count} = number of eggs, {s} = "" or "s"
  // =============================================================
  text: {
    announcementActive:  "🥚 Easter egg hunt is live — {count} egg{s} hidden right now!",
    announcementEnded:   "🐣 Egg hunt is over for today! The egg was at",
    celebrationTitle:    "YOU FOUND IT! 🥚",
    celebrationSubtitle: "Go to checkout QUICK to get the plate carrier!",
    celebrationDismiss:  "Tap anywhere to continue",
    toastSuccess:        "🥚 You found it! A surprise has been added to your cart.",
    toastSoldOut:        "Someone was faster! This egg is gone. 🐣",
    toastError:          "Something went wrong — please try again.",
    eggAriaLabel:        "Hidden easter egg — click me!",
  },

  eggs: [
    {
      name: "egg1-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/micro-map",                 // exact pathname match
        top: "8%",
        left: "50%"
      }
    },
    {
      name: "egg2-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe-2",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/scorpion-beanie",                 // exact pathname match
        top: "30%",
        left: "80%"
      }
    },
    
  ]
};
const HUNT_EGG_CONFIG = {
  previewKey: "",        // "" = visible to everyone - localStorage.setItem("agiliteEaster", 1)
  rememberClicked: false,              // true = hide egg for this browser once clicked
  enableAnnouncementOverride: true,    // true = Easter messages replace the announcement bar while hunt is live or just ended today
  eggImageUrl: "https://cdn.shopify.com/s/files/1/0526/4001/files/MTC_RGG_WEBP_60x60_dfe6cc5e-7e39-4a26-95b4-2c1c635d9e96.webp?v=1774371071",

  // =============================================================
  //  All user-facing text — edit freely
  //  In announcementActive: {count} = number of eggs, {s} = "" or "s"
  // =============================================================
  text: {
    announcementActive:  "🥚 Easter egg hunt is live — {count} egg{s} hidden right now!",
    announcementEnded:   "🐣 Egg hunt is over for today! The egg was at",
    celebrationTitle:    "YOU FOUND IT! 🥚",
    celebrationSubtitle: "Go to checkout QUICK to get the plate carrier!",
    celebrationDismiss:  "Tap anywhere to continue",
    toastSuccess:        "🥚 You found it! A surprise has been added to your cart.",
    toastSoldOut:        "Someone was faster! This egg is gone. 🐣",
    toastError:          "Something went wrong — please try again.",
    eggAriaLabel:        "Hidden easter egg — click me!",
  },

  eggs: [
    {
      name: "egg1-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/pincer-loadout",                 // exact pathname match
        top: "8%",
        left: "50%"
      }
    },
    {
      name: "egg2-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe-2",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/agilite-multicam-trucker-hat",                 // exact pathname match
        top: "30%",
        left: "80%"
      }
    },
    
  ]
};
const EASTER_EGG_REAL = {
  previewKey: "",        // "" = visible to everyone - localStorage.setItem("agiliteEaster", 1)
  rememberClicked: false,              // true = hide egg for this browser once clicked
  enableAnnouncementOverride: true,    // true = Easter messages replace the announcement bar while hunt is live or just ended today
  eggImageUrl: "https://cdn.shopify.com/s/files/1/0526/4001/files/MTC_RGG_WEBP_60x60_dfe6cc5e-7e39-4a26-95b4-2c1c635d9e96.webp?v=1774371071",

  // =============================================================
  //  All user-facing text — edit freely
  //  In announcementActive: {count} = number of eggs, {s} = "" or "s"
  // =============================================================
  text: {
    announcementActive:  "🥚 Easter egg hunt is live — {count} egg{s} hidden right now!",
    announcementEnded:   "🐣 Egg hunt is over for today! The egg was at",
    celebrationTitle:    "YOU FOUND IT! 🥚",
    celebrationSubtitle: "Go to checkout QUICK to get the plate carrier!",
    celebrationDismiss:  "Tap anywhere to continue",
    toastSuccess:        "🥚 You found it! A surprise has been added to your cart.",
    toastSoldOut:        "Someone was faster! This egg is gone. 🐣",
    toastError:          "Something went wrong — please try again.",
    eggAriaLabel:        "Hidden easter egg — click me!",
  },

  eggs: [
    {
      name: "egg1-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/amap-iii-buckles",                 // exact pathname match
        top: "8%",
        left: "50%"
      }
    },
    {
      name: "egg2-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe-2",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/scorpion-patch",                 // exact pathname match
        top: "30%",
        left: "80%"
      }
    },
    
  ]
};
const GEAR_RECOMMENDATIONS = {
  previewKey: "",        // "" = visible to everyone - localStorage.setItem("agiliteEaster", 1)
  rememberClicked: false,              // true = hide egg for this browser once clicked
  enableAnnouncementOverride: true,    // true = Easter messages replace the announcement bar while hunt is live or just ended today
  eggImageUrl: "https://cdn.shopify.com/s/files/1/0526/4001/files/MTC_RGG_WEBP_dsf60x60_dfe6cc5e-7e39-4a26-95b4-2c1c635d9e96.webp?v=1775308463",

  // =============================================================
  //  All user-facing text — edit freely
  //  In announcementActive: {count} = number of eggs, {s} = "" or "s"
  // =============================================================
  text: {
    announcementActive:  "🥚 Easter egg hunt is live — {count} egg{s} hidden right now!",
    announcementEnded:   "🐣 Egg hunt is over for today! The egg was at",
    celebrationTitle:    "YOU FOUND IT! 🥚",
    celebrationSubtitle: "Go to checkout QUICK to get the plate carrier!",
    celebrationDismiss:  "Tap anywhere to continue",
    toastSuccess:        "🥚 You found it! A surprise has been added to your cart.",
    toastSoldOut:        "Someone was faster! This egg is gone. 🐣",
    toastError:          "Something went wrong — please try again.",
    eggAriaLabel:        "Hidden easter egg — click me!",
  },

  eggs: [
    {
      name: "egg1-day2",
      productHandle: "k-zero-plate-carrier-rhodesian-brushstroke-2vsbe4g",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-04T16:00:00",
        end:   "2026-04-05T09:00:00"
      },
      placement: {
        url: "/products/emergence-fanny-pack",                 // exact pathname match
        top: "8%",
        left: "50%"
      }
    },
    {
      name: "egg2-day2",
      productHandle: "k-zero-plate-carrier-rhodesian-brushstroke-sdvne4",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-04T16:00:00",
        end:   "2026-04-05T09:00:00"
      },
      placement: {
        url: "/products/matol-pouch",                 // exact pathname match
        top: "20%",
        left: "50%"
      }
    },
    
  ]
};
const SUGGEST_SYSTEM = {
  previewKey: "",        // "" = visible to everyone - localStorage.setItem("agiliteEaster", 1)
  rememberClicked: false,              // true = hide egg for this browser once clicked
  enableAnnouncementOverride: true,    // true = Easter messages replace the announcement bar while hunt is live or just ended today
  eggImageUrl: "https://cdn.shopify.com/s/files/1/0526/4001/files/MTC_RGG_WEBP_60x60_dfe6cc5e-7e39-4a26-95b4-2c1c635d9e96.webp?v=1774371071",

  // =============================================================
  //  All user-facing text — edit freely
  //  In announcementActive: {count} = number of eggs, {s} = "" or "s"
  // =============================================================
  text: {
    announcementActive:  "🥚 Easter egg hunt is live — {count} egg{s} hidden right now!",
    announcementEnded:   "🐣 Egg hunt is over for today! The egg was at",
    celebrationTitle:    "YOU FOUND IT! 🥚",
    celebrationSubtitle: "Go to checkout QUICK to get the plate carrier!",
    celebrationDismiss:  "Tap anywhere to continue",
    toastSuccess:        "🥚 You found it! A surprise has been added to your cart.",
    toastSoldOut:        "Someone was faster! This egg is gone. 🐣",
    toastError:          "Something went wrong — please try again.",
    eggAriaLabel:        "Hidden easter egg — click me!",
  },

  eggs: [
    {
      name: "egg1-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripedbe5",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/pincer-pistol-single-pouch",                 // exact pathname match
        top: "8%",
        left: "50%"
      }
    },
    {
      name: "egg2-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe-2ASGRg",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/k-zero-plate-carrier",                 // exact pathname match
        top: "30%",
        left: "80%"
      }
    },
    
  ]
};
const GEAR_RECOМMENDATIONS = {
  previewKey: "",        // "" = visible to everyone - localStorage.setItem("agiliteEaster", 1)
  rememberClicked: false,              // true = hide egg for this browser once clicked
  enableAnnouncementOverride: true,    // true = Easter messages replace the announcement bar while hunt is live or just ended today
  eggImageUrl: "https://cdn.shopify.com/s/files/1/0526/4001/files/MTC_RGG_WEBP_60x60_dfe6cc5e-7e39-4a26-95b4-2c1c635d9e96.webp?v=1774371071",

  // =============================================================
  //  All user-facing text — edit freely
  //  In announcementActive: {count} = number of eggs, {s} = "" or "s"
  // =============================================================
  text: {
    announcementActive:  "🥚 Easter egg hunt is live — {count} egg{s} hidden right now!",
    announcementEnded:   "🐣 Egg hunt is over for today! The egg was at",
    celebrationTitle:    "YOU FOUND IT! 🥚",
    celebrationSubtitle: "Go to checkout QUICK to get the plate carrier!",
    celebrationDismiss:  "Tap anywhere to continue",
    toastSuccess:        "🥚 You found it! A surprise has been added to your cart.",
    toastSoldOut:        "Someone was faster! This egg is gone. 🐣",
    toastError:          "Something went wrong — please try again.",
    eggAriaLabel:        "Hidden easter egg — click me!",
  },

  eggs: [
    {
      name: "egg1-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripedwefebe5",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/flank-side-plate-carriers-with-blindside-level-3st-ceramic-plates",                 // exact pathname match
        top: "8%",
        left: "50%"
      }
    },
    {
      name: "egg2-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe-2AShtrGRg",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/k-zero-sf-plate-carrier",                 // exact pathname match
        top: "30%",
        left: "80%"
      }
    },
    
  ]
};
const EASTER_HUNT_EGG_CONFIG = {
  previewKey: "",        // "" = visible to everyone - localStorage.setItem("agiliteEaster", 1)
  rememberClicked: false,              // true = hide egg for this browser once clicked
  enableAnnouncementOverride: true,    // true = Easter messages replace the announcement bar while hunt is live or just ended today
  eggImageUrl: "https://cdn.shopify.com/s/files/1/0526/4001/files/MTC_RGG_WEBP_60x60_dfe6cc5e-7e39-4a26-95b4-2c1c635d9e96.webp?v=1774371071",

  // =============================================================
  //  All user-facing text — edit freely
  //  In announcementActive: {count} = number of eggs, {s} = "" or "s"
  // =============================================================
  text: {
    announcementActive:  "🥚 Easter egg hunt is live — {count} egg{s} hidden right now!",
    announcementEnded:   "🐣 Egg hunt is over for today! The egg was at",
    celebrationTitle:    "YOU FOUND IT! 🥚",
    celebrationSubtitle: "Go to checkout QUICK to get the plate carrier!",
    celebrationDismiss:  "Tap anywhere to continue",
    toastSuccess:        "🥚 You found it! A surprise has been added to your cart.",
    toastSoldOut:        "Someone was faster! This egg is gone. 🐣",
    toastError:          "Something went wrong — please try again.",
    eggAriaLabel:        "Hidden easter egg — click me!",
  },

  eggs: [
    {
      name: "egg1-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe2gasr",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/jump-retention-tabs",                 // exact pathname match
        top: "8%",
        left: "50%"
      }
    },
    {
      name: "egg2-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe-245gwrvs",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/ag1-5-56-single-mag-pouch",                 // exact pathname match
        top: "30%",
        left: "80%"
      }
    },
    
  ]
};
const EASTER_EGG_CHEATERS_CONFIG = {
  previewKey: "",        // "" = visible to everyone - localStorage.setItem("agiliteEaster", 1)
  rememberClicked: false,              // true = hide egg for this browser once clicked
  enableAnnouncementOverride: true,    // true = Easter messages replace the announcement bar while hunt is live or just ended today
  eggImageUrl: "https://cdn.shopify.com/s/files/1/0526/4001/files/MTC_RGG_WEBP_60x60_dfe6cc5e-7e39-4a26-95b4-2c1c635d9e96.webp?v=1774371071",

  // =============================================================
  //  All user-facing text — edit freely
  //  In announcementActive: {count} = number of eggs, {s} = "" or "s"
  // =============================================================
  text: {
    announcementActive:  "🥚 Easter egg hunt is live — {count} egg{s} hidden right now!",
    announcementEnded:   "🐣 Egg hunt is over for today! The egg was at",
    celebrationTitle:    "YOU FOUND IT! 🥚",
    celebrationSubtitle: "Go to checkout QUICK to get the plate carrier!",
    celebrationDismiss:  "Tap anywhere to continue",
    toastSuccess:        "🥚 You found it! A surprise has been added to your cart.",
    toastSoldOut:        "Someone was faster! This egg is gone. 🐣",
    toastError:          "Something went wrong — please try again.",
    eggAriaLabel:        "Hidden easter egg — click me!",
  },

  eggs: [
    {
      name: "egg1-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripegerht54",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/amap-iii-assault-pack",                 // exact pathname match
        top: "8%",
        left: "50%"
      }
    },
    {
      name: "egg2-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe-243ygreg",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/operator-level-4-rifle-rated-stand-alone-body-armor",                 // exact pathname match
        top: "30%",
        left: "80%"
      }
    },
    
  ]
};
const EASTER_EGG_2026_CONFIG = {
  previewKey: "",        // "" = visible to everyone - localStorage.setItem("agiliteEaster", 1)
  rememberClicked: false,              // true = hide egg for this browser once clicked
  enableAnnouncementOverride: true,    // true = Easter messages replace the announcement bar while hunt is live or just ended today
  eggImageUrl: "https://cdn.shopify.com/s/files/1/0526/4001/files/MTC_RGG_WEBP_60x60_dfe6cc5e-7e39-4a26-95b4-2c1c635d9e96.webp?v=1774371071",

  // =============================================================
  //  All user-facing text — edit freely
  //  In announcementActive: {count} = number of eggs, {s} = "" or "s"
  // =============================================================
  text: {
    announcementActive:  "🥚 Easter egg hunt is live — {count} egg{s} hidden right now!",
    announcementEnded:   "🐣 Egg hunt is over for today! The egg was at",
    celebrationTitle:    "YOU FOUND IT! 🥚",
    celebrationSubtitle: "Go to checkout QUICK to get the plate carrier!",
    celebrationDismiss:  "Tap anywhere to continue",
    toastSuccess:        "🥚 You found it! A surprise has been added to your cart.",
    toastSoldOut:        "Someone was faster! This egg is gone. 🐣",
    toastError:          "Something went wrong — please try again.",
    eggAriaLabel:        "Hidden easter egg — click me!",
  },

  eggs: [
    {
      name: "egg1-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe235tfs",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/rear-pouch",                 // exact pathname match
        top: "8%",
        left: "50%"
      }
    },
    {
      name: "egg2-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe-2fegr3",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/helmet-bridge",                 // exact pathname match
        top: "30%",
        left: "80%"
      }
    },
    
  ]
};
const EASTER_EGG_HUNT_CONFIG = {
  previewKey: "",        // "" = visible to everyone - localStorage.setItem("agiliteEaster", 1)
  rememberClicked: false,              // true = hide egg for this browser once clicked
  enableAnnouncementOverride: true,    // true = Easter messages replace the announcement bar while hunt is live or just ended today
  eggImageUrl: "https://cdn.shopify.com/s/files/1/0526/4001/files/MTC_RGG_WEBP_60x60_dfe6cc5e-7e39-4a26-95b4-2c1c635d9e96.webp?v=1774371071",

  // =============================================================
  //  All user-facing text — edit freely
  //  In announcementActive: {count} = number of eggs, {s} = "" or "s"
  // =============================================================
  text: {
    announcementActive:  "🥚 Easter egg hunt is live — {count} egg{s} hidden right now!",
    announcementEnded:   "🐣 Egg hunt is over for today! The egg was at",
    celebrationTitle:    "YOU FOUND IT! 🥚",
    celebrationSubtitle: "Go to checkout QUICK to get the plate carrier!",
    celebrationDismiss:  "Tap anywhere to continue",
    toastSuccess:        "🥚 You found it! A surprise has been added to your cart.",
    toastSoldOut:        "Someone was faster! This egg is gone. 🐣",
    toastError:          "Something went wrong — please try again.",
    eggAriaLabel:        "Hidden easter egg — click me!",
  },

  eggs: [
    {
      name: "egg1-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe23fw4",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/matol-pouch",                 // exact pathname match
        top: "8%",
        left: "50%"
      }
    },
    {
      name: "egg2-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe-2123rfe",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/k-zero-sf-bundle",                 // exact pathname match
        top: "30%",
        left: "80%"
      }
    },
    
  ]
};
const BUNNY_EGG_CONFIG = {
  previewKey: "",        // "" = visible to everyone - localStorage.setItem("agiliteEaster", 1)
  rememberClicked: false,              // true = hide egg for this browser once clicked
  enableAnnouncementOverride: true,    // true = Easter messages replace the announcement bar while hunt is live or just ended today
  eggImageUrl: "https://cdn.shopify.com/s/files/1/0526/4001/files/MTC_RGG_WEBP_60x60_dfe6cc5e-7e39-4a26-95b4-2c1c635d9e96.webp?v=1774371071",

  // =============================================================
  //  All user-facing text — edit freely
  //  In announcementActive: {count} = number of eggs, {s} = "" or "s"
  // =============================================================
  text: {
    announcementActive:  "🥚 Easter egg hunt is live — {count} egg{s} hidden right now!",
    announcementEnded:   "🐣 Egg hunt is over for today! The egg was at",
    celebrationTitle:    "YOU FOUND IT! 🥚",
    celebrationSubtitle: "Go to checkout QUICK to get the plate carrier!",
    celebrationDismiss:  "Tap anywhere to continue",
    toastSuccess:        "🥚 You found it! A surprise has been added to your cart.",
    toastSoldOut:        "Someone was faster! This egg is gone. 🐣",
    toastError:          "Something went wrong — please try again.",
    eggAriaLabel:        "Hidden easter egg — click me!",
  },

  eggs: [
    {
      name: "egg1-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe23rf",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/emergence-fanny-pack",                 // exact pathname match
        top: "8%",
        left: "50%"
      }
    },
    {
      name: "egg2-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe-23rfwsf",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/general-purpose-pouch-large",                 // exact pathname match
        top: "30%",
        left: "80%"
      }
    },
    
  ]
};
const EASTER_EGG_LOCATIONS = {
  previewKey: "",        // "" = visible to everyone - localStorage.setItem("agiliteEaster", 1)
  rememberClicked: false,              // true = hide egg for this browser once clicked
  enableAnnouncementOverride: true,    // true = Easter messages replace the announcement bar while hunt is live or just ended today
  eggImageUrl: "https://cdn.shopify.com/s/files/1/0526/4001/files/MTC_RGG_WEBP_60x60_dfe6cc5e-7e39-4a26-95b4-2c1c635d9e96.webp?v=1774371071",

  // =============================================================
  //  All user-facing text — edit freely
  //  In announcementActive: {count} = number of eggs, {s} = "" or "s"
  // =============================================================
  text: {
    announcementActive:  "🥚 Easter egg hunt is live — {count} egg{s} hidden right now!",
    announcementEnded:   "🐣 Egg hunt is over for today! The egg was at",
    celebrationTitle:    "YOU FOUND IT! 🥚",
    celebrationSubtitle: "Go to checkout QUICK to get the plate carrier!",
    celebrationDismiss:  "Tap anywhere to continue",
    toastSuccess:        "🥚 You found it! A surprise has been added to your cart.",
    toastSoldOut:        "Someone was faster! This egg is gone. 🐣",
    toastError:          "Something went wrong — please try again.",
    eggAriaLabel:        "Hidden easter egg — click me!",
  },

  eggs: [
    {
      name: "egg1-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripeqweg33",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/k-zero-sf-plate-carrier-with-level-4-plates-2-x-level-4-warrior-plates",                 // exact pathname match
        top: "8%",
        left: "50%"
      }
    },
    {
      name: "egg2-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe-2235ver",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/k-zero-sf-plate-carrier-with-plates-2-x-level-3st-protector-plates",                 // exact pathname match
        top: "30%",
        left: "80%"
      }
    },
    
  ]
};
const EASTER_EGG_SPOTS = {
  previewKey: "",        // "" = visible to everyone - localStorage.setItem("agiliteEaster", 1)
  rememberClicked: false,              // true = hide egg for this browser once clicked
  enableAnnouncementOverride: true,    // true = Easter messages replace the announcement bar while hunt is live or just ended today
  eggImageUrl: "https://cdn.shopify.com/s/files/1/0526/4001/files/MTC_RGG_WEBP_60x60_dfe6cc5e-7e39-4a26-95b4-2c1c635d9e96.webp?v=1774371071",

  // =============================================================
  //  All user-facing text — edit freely
  //  In announcementActive: {count} = number of eggs, {s} = "" or "s"
  // =============================================================
  text: {
    announcementActive:  "🥚 Easter egg hunt is live — {count} egg{s} hidden right now!",
    announcementEnded:   "🐣 Egg hunt is over for today! The egg was at",
    celebrationTitle:    "YOU FOUND IT! 🥚",
    celebrationSubtitle: "Go to checkout QUICK to get the plate carrier!",
    celebrationDismiss:  "Tap anywhere to continue",
    toastSuccess:        "🥚 You found it! A surprise has been added to your cart.",
    toastSoldOut:        "Someone was faster! This egg is gone. 🐣",
    toastError:          "Something went wrong — please try again.",
    eggAriaLabel:        "Hidden easter egg — click me!",
  },

  eggs: [
    {
      name: "egg1-day2",
      productHandle: "k-zero-plate-carrier-tiger-striper2fw4wfv",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/testing-team-alpha-hat",                 // exact pathname match
        top: "8%",
        left: "50%"
      }
    },
    {
      name: "egg2-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe-2hebdvxty",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/gear-tester-shirt",                 // exact pathname match
        top: "30%",
        left: "80%"
      }
    },
    
  ]
};
const EASTER_EGG_FOR_CHATGPT = {
  previewKey: "",        // "" = visible to everyone - localStorage.setItem("agiliteEaster", 1)
  rememberClicked: false,              // true = hide egg for this browser once clicked
  enableAnnouncementOverride: true,    // true = Easter messages replace the announcement bar while hunt is live or just ended today
  eggImageUrl: "https://cdn.shopify.com/s/files/1/0526/4001/files/MTC_RGG_WEBP_60x60_dfe6cc5e-7e39-4a26-95b4-2c1c635d9e96.webp?v=1774371071",

  // =============================================================
  //  All user-facing text — edit freely
  //  In announcementActive: {count} = number of eggs, {s} = "" or "s"
  // =============================================================
  text: {
    announcementActive:  "🥚 Easter egg hunt is live — {count} egg{s} hidden right now!",
    announcementEnded:   "🐣 Egg hunt is over for today! The egg was at",
    celebrationTitle:    "YOU FOUND IT! 🥚",
    celebrationSubtitle: "Go to checkout QUICK to get the plate carrier!",
    celebrationDismiss:  "Tap anywhere to continue",
    toastSuccess:        "🥚 You found it! A surprise has been added to your cart.",
    toastSoldOut:        "Someone was faster! This egg is gone. 🐣",
    toastError:          "Something went wrong — please try again.",
    eggAriaLabel:        "Hidden easter egg — click me!",
  },

  eggs: [
    {
      name: "egg1-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe245wtfgv",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/reaper-rig-micro-rig-bundle",                 // exact pathname match
        top: "8%",
        left: "50%"
      }
    },
    {
      name: "egg2-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe-2fgvvdf4",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/modular-elastic-cummerbund",                 // exact pathname match
        top: "30%",
        left: "80%"
      }
    },
    
  ]
};
const EASTER_EGG_FREE_PLATE_CARRIER = {
  previewKey: "",        // "" = visible to everyone - localStorage.setItem("agiliteEaster", 1)
  rememberClicked: false,              // true = hide egg for this browser once clicked
  enableAnnouncementOverride: true,    // true = Easter messages replace the announcement bar while hunt is live or just ended today
  eggImageUrl: "https://cdn.shopify.com/s/files/1/0526/4001/files/MTC_RGG_WEBP_60x60_dfe6cc5e-7e39-4a26-95b4-2c1c635d9e96.webp?v=1774371071",

  // =============================================================
  //  All user-facing text — edit freely
  //  In announcementActive: {count} = number of eggs, {s} = "" or "s"
  // =============================================================
  text: {
    announcementActive:  "🥚 Easter egg hunt is live — {count} egg{s} hidden right now!",
    announcementEnded:   "🐣 Egg hunt is over for today! The egg was at",
    celebrationTitle:    "YOU FOUND IT! 🥚",
    celebrationSubtitle: "Go to checkout QUICK to get the plate carrier!",
    celebrationDismiss:  "Tap anywhere to continue",
    toastSuccess:        "🥚 You found it! A surprise has been added to your cart.",
    toastSoldOut:        "Someone was faster! This egg is gone. 🐣",
    toastError:          "Something went wrong — please try again.",
    eggAriaLabel:        "Hidden easter egg — click me!",
  },

  eggs: [
    {
      name: "egg1-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripeasdwe43",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/santa-scorpion-patch",                 // exact pathname match
        top: "8%",
        left: "50%"
      }
    },
    {
      name: "egg2-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe-2feeere4",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/k19-plate-carrier-3-0-wolf-grey",                 // exact pathname match
        top: "30%",
        left: "80%"
      }
    },
    
  ]
};
const EASTER_EGG_SETUP = {
  previewKey: "",        // "" = visible to everyone - localStorage.setItem("agiliteEaster", 1)
  rememberClicked: false,              // true = hide egg for this browser once clicked
  enableAnnouncementOverride: true,    // true = Easter messages replace the announcement bar while hunt is live or just ended today
  eggImageUrl: "https://cdn.shopify.com/s/files/1/0526/4001/files/MTC_RGG_WEBP_60x60_dfe6cc5e-7e39-4a26-95b4-2c1c635d9e96.webp?v=1774371071",

  // =============================================================
  //  All user-facing text — edit freely
  //  In announcementActive: {count} = number of eggs, {s} = "" or "s"
  // =============================================================
  text: {
    announcementActive:  "🥚 Easter egg hunt is live — {count} egg{s} hidden right now!",
    announcementEnded:   "🐣 Egg hunt is over for today! The egg was at",
    celebrationTitle:    "YOU FOUND IT! 🥚",
    celebrationSubtitle: "Go to checkout QUICK to get the plate carrier!",
    celebrationDismiss:  "Tap anywhere to continue",
    toastSuccess:        "🥚 You found it! A surprise has been added to your cart.",
    toastSoldOut:        "Someone was faster! This egg is gone. 🐣",
    toastError:          "Something went wrong — please try again.",
    eggAriaLabel:        "Hidden easter egg — click me!",
  },

  eggs: [
    {
      name: "egg1-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripewerw3",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/magnetix-edc-battle-belt",                 // exact pathname match
        top: "8%",
        left: "50%"
      }
    },
    {
      name: "egg2-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe-2",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/sar-orange-scorpion-patch",                 // exact pathname match
        top: "30%",
        left: "80%"
      }
    },
    
  ]
};
const EASTER_EGG_DAY2 = {
  previewKey: "",        // "" = visible to everyone - localStorage.setItem("agiliteEaster", 1)
  rememberClicked: false,              // true = hide egg for this browser once clicked
  enableAnnouncementOverride: true,    // true = Easter messages replace the announcement bar while hunt is live or just ended today
  eggImageUrl: "https://cdn.shopify.com/s/files/1/0526/4001/files/MTC_RGG_WEBP_60x60_dfe6cc5e-7e39-4a26-95b4-2c1c635d9e96.webp?v=1774371071",

  // =============================================================
  //  All user-facing text — edit freely
  //  In announcementActive: {count} = number of eggs, {s} = "" or "s"
  // =============================================================
  text: {
    announcementActive:  "🥚 Easter egg hunt is live — {count} egg{s} hidden right now!",
    announcementEnded:   "🐣 Egg hunt is over for today! The egg was at",
    celebrationTitle:    "YOU FOUND IT! 🥚",
    celebrationSubtitle: "Go to checkout QUICK to get the plate carrier!",
    celebrationDismiss:  "Tap anywhere to continue",
    toastSuccess:        "🥚 You found it! A surprise has been added to your cart.",
    toastSoldOut:        "Someone was faster! This egg is gone. 🐣",
    toastError:          "Something went wrong — please try again.",
    eggAriaLabel:        "Hidden easter egg — click me!",
  },

  eggs: [
    {
      name: "egg1-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripeqwd23r",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/pincer-placard-2nd-layer-admin-pouch-m81-woodland",                 // exact pathname match
        top: "8%",
        left: "50%"
      }
    },
    {
      name: "egg2-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe-234654ygsdf",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/md2-compact-trauma-kit",                 // exact pathname match
        top: "30%",
        left: "80%"
      }
    },
    
  ]
};
const EASTER_EGG_FREE = {
  previewKey: "",        // "" = visible to everyone - localStorage.setItem("agiliteEaster", 1)
  rememberClicked: false,              // true = hide egg for this browser once clicked
  enableAnnouncementOverride: true,    // true = Easter messages replace the announcement bar while hunt is live or just ended today
  eggImageUrl: "https://cdn.shopify.com/s/files/1/0526/4001/files/MTC_RGG_WEBP_60x60_dfe6cc5e-7e39-4a26-95b4-2c1c635d9e96.webp?v=1774371071",

  // =============================================================
  //  All user-facing text — edit freely
  //  In announcementActive: {count} = number of eggs, {s} = "" or "s"
  // =============================================================
  text: {
    announcementActive:  "🥚 Easter egg hunt is live — {count} egg{s} hidden right now!",
    announcementEnded:   "🐣 Egg hunt is over for today! The egg was at",
    celebrationTitle:    "YOU FOUND IT! 🥚",
    celebrationSubtitle: "Go to checkout QUICK to get the plate carrier!",
    celebrationDismiss:  "Tap anywhere to continue",
    toastSuccess:        "🥚 You found it! A surprise has been added to your cart.",
    toastSoldOut:        "Someone was faster! This egg is gone. 🐣",
    toastError:          "Something went wrong — please try again.",
    eggAriaLabel:        "Hidden easter egg — click me!",
  },

  eggs: [
    {
      name: "egg1-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe32rfcdsv",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/combat-medic-bundle",                 // exact pathname match
        top: "8%",
        left: "50%"
      }
    },
    {
      name: "egg2-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe-223r23532",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/discounted-k-zero-plate-carrier-runner-up",                 // exact pathname match
        top: "30%",
        left: "80%"
      }
    },
    
  ]
};
const EASTER_EGG_FREE_FOR_EVERYONE = {
  previewKey: "",        // "" = visible to everyone - localStorage.setItem("agiliteEaster", 1)
  rememberClicked: false,              // true = hide egg for this browser once clicked
  enableAnnouncementOverride: true,    // true = Easter messages replace the announcement bar while hunt is live or just ended today
  eggImageUrl: "https://cdn.shopify.com/s/files/1/0526/4001/files/MTC_RGG_WEBP_60x60_dfe6cc5e-7e39-4a26-95b4-2c1c635d9e96.webp?v=1774371071",

  // =============================================================
  //  All user-facing text — edit freely
  //  In announcementActive: {count} = number of eggs, {s} = "" or "s"
  // =============================================================
  text: {
    announcementActive:  "🥚 Easter egg hunt is live — {count} egg{s} hidden right now!",
    announcementEnded:   "🐣 Egg hunt is over for today! The egg was at",
    celebrationTitle:    "YOU FOUND IT! 🥚",
    celebrationSubtitle: "Go to checkout QUICK to get the plate carrier!",
    celebrationDismiss:  "Tap anywhere to continue",
    toastSuccess:        "🥚 You found it! A surprise has been added to your cart.",
    toastSoldOut:        "Someone was faster! This egg is gone. 🐣",
    toastError:          "Something went wrong — please try again.",
    eggAriaLabel:        "Hidden easter egg — click me!",
  },

  eggs: [
    {
      name: "egg1-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe23rfcdv",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/scorpion-logo-hat",                 // exact pathname match
        top: "8%",
        left: "50%"
      }
    },
    {
      name: "egg2-day2",
      productHandle: "k-zero-plate-carrier-tiger-stripe-2234rdcvdsvf",
      activeOverride: null,       // null | true | false
      notes: "Top-left corner of homepage, behind nav",
      timeframe: {
        start: "2026-04-03T16:58:00",
        end:   "2026-04-04T09:00:00"
      },
      placement: {
        url: "/products/scorpion-logo-hat2",                 // exact pathname match
        top: "30%",
        left: "80%"
      }
    },
    
  ]
};
// =============================================================
//  CSS injected once on first use
// =============================================================
function injectStyles() {
  if (document.getElementById("easter-egg-styles")) return;
  const style = document.createElement("style");
  style.id = "easter-egg-styles";
  style.textContent = `
    @keyframes egg-float {
      0%, 100% { transform: translateY(0px) rotate(-3deg); }
      50%       { transform: translateY(-6px) rotate(3deg); }
    }
    @keyframes egg-pop {
      0%   { transform: scale(1);   opacity: 1; }
      50%  { transform: scale(1.8); opacity: 0.6; }
      100% { transform: scale(0);   opacity: 0; }
    }
    .easter-egg-wrapper {
      position: absolute;
      z-index: 99999;
      cursor: pointer;
      animation: egg-float 2.4s ease-in-out infinite;
      transition: filter 0.15s;
    }
    .easter-egg-wrapper:hover { filter: brightness(1.15) drop-shadow(0 0 6px rgba(255,200,50,.7)); }
    .easter-egg-wrapper img  { height: 30px; display: block; }
    .easter-egg-wrapper.popping {
      animation: egg-pop 0.35s ease-out forwards;
      pointer-events: none;
    }
    #easter-egg-toast {
      position: fixed;
      bottom: 24px;
      left: 50%;
      transform: translateX(-50%) translateY(80px);
      background: #1a1a1a;
      color: #fff;
      padding: 12px 20px;
      border-radius: 8px;
      font-size: 14px;
      font-family: sans-serif;
      box-shadow: 0 4px 18px rgba(0,0,0,.35);
      z-index: 100000;
      transition: transform 0.3s ease, opacity 0.3s ease;
      opacity: 0;
      white-space: nowrap;
    }
    #easter-egg-toast.show {
      transform: translateX(-50%) translateY(0);
      opacity: 1;
    }
  `;
  document.head.appendChild(style);
}

// =============================================================
//  Celebration CSS — injected once
// =============================================================
function injectCelebrationStyles() {
  if (document.getElementById("egg-celebration-styles")) return;
  const style = document.createElement("style");
  style.id = "egg-celebration-styles";
  style.textContent = `
    @keyframes egc-overlay-in {
      from { opacity: 0; }
      to   { opacity: 1; }
    }
    @keyframes egc-bg-pulse {
      0%,100% { background-position: 0% 50%; }
      50%      { background-position: 100% 50%; }
    }
    @keyframes egc-ring {
      0%   { transform: translate(-50%,-50%) scale(0.4); opacity: 0.9; }
      100% { transform: translate(-50%,-50%) scale(2.4); opacity: 0; }
    }
    @keyframes egc-egg-in {
      0%   { opacity: 0; transform: scale(0.1) rotate(-25deg); }
      60%  { opacity: 1; transform: scale(1.12) rotate(6deg); }
      80%  { transform: scale(0.96) rotate(-2deg); }
      100% { opacity: 1; transform: scale(1) rotate(0deg); }
    }
    @keyframes egc-title-in {
      0%   { opacity: 0; transform: translateY(24px) scale(0.85); }
      70%  { transform: translateY(-4px) scale(1.04); }
      100% { opacity: 1; transform: translateY(0) scale(1); }
    }
    @keyframes egc-sub-in {
      from { opacity: 0; transform: translateY(14px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    @keyframes egc-sparkle {
      0%   { opacity: 0; transform: scale(0) rotate(0deg); }
      40%  { opacity: 1; }
      100% { opacity: 0; transform: scale(2.2) rotate(135deg); }
    }
    @keyframes egc-confetti-fall {
      0%   { transform: translateY(-40px) rotate(0deg);   opacity: 1; }
      100% { transform: translateY(110vh) rotate(720deg); opacity: 0.3; }
    }
    @keyframes egc-rain-egg {
      0%   { transform: translateY(-60px) rotate(-10deg); opacity: 1; }
      100% { transform: translateY(108vh) rotate(30deg);  opacity: 0.5; }
    }
    @keyframes egc-glow-pulse {
      0%,100% { filter: drop-shadow(0 0 22px rgba(255,210,30,0.9)) drop-shadow(0 0 55px rgba(255,150,0,0.5)); }
      50%      { filter: drop-shadow(0 0 40px rgba(255,230,80,1))   drop-shadow(0 0 90px rgba(255,180,0,0.8)); }
    }
    @keyframes egc-title-glow {
      0%,100% { text-shadow: 0 0 20px rgba(255,215,0,0.9), 0 0 50px rgba(255,180,0,0.5); }
      50%      { text-shadow: 0 0 35px rgba(255,240,80,1), 0 0 80px rgba(255,200,0,0.8), 0 0 120px rgba(255,150,0,0.4); }
    }
    @keyframes egc-hint-pulse {
      0%,100% { opacity: 0.85; transform: translateX(-50%) scale(1); }
      50%      { opacity: 1;    transform: translateX(-50%) scale(1.04); }
    }
    @keyframes egc-ambient-spin {
      from { transform: translate(-50%,-50%) rotate(0deg); }
      to   { transform: translate(-50%,-50%) rotate(360deg); }
    }
  `;
  document.head.appendChild(style);
}

// =============================================================
//  Announcement-bar Easter styles — injected once
// =============================================================
function injectAnnouncementEasterStyles() {
  if (document.getElementById("easter-announcement-styles")) return;
  const style = document.createElement("style");
  style.id = "easter-announcement-styles";
  style.textContent = `
    @keyframes easter-bar-gradient {
      0%, 100% { background-position: 0% 50%; }
      50%       { background-position: 100% 50%; }
    }
    [data-announcement-bar].easter-announcement {
      background: linear-gradient(135deg, #ffd1dc, #fffacd, #d4f1d4, #e8d5f5) !important;
      background-size: 300% 300% !important;
      animation: easter-bar-gradient 6s ease infinite !important;
    }
    [data-announcement-bar].easter-announcement p {
      color: #5b2d8a !important;
    }
  `;
  document.head.appendChild(style);
}

// =============================================================
//  Toast helper
// =============================================================
let toastTimer;
function showToast(message) {
  let toast = document.getElementById("easter-egg-toast");
  if (!toast) {
    toast = document.createElement("div");
    toast.id = "easter-egg-toast";
    document.body.appendChild(toast);
  }
  toast.textContent = message;
  clearTimeout(toastTimer);
  toast.classList.remove("show");
  void toast.offsetWidth;
  toast.classList.add("show");
  toastTimer = setTimeout(() => toast.classList.remove("show"), 3800);
}

// =============================================================
//  Product data fetch — returns { variantId, imageUrl }
// =============================================================
async function getProductData(handle) {
  const res = await fetch(`/products/${handle}.js`);
  if (!res.ok) return { variantId: null, imageUrl: null };
  const product = await res.json();
  const variant = (product.variants || []).find(v => v.available);
  let imageUrl = product.featured_image || (product.images && product.images[0]) || null;
  if (imageUrl && imageUrl.startsWith("//")) imageUrl = "https:" + imageUrl;
  return { variantId: variant ? variant.id : null, imageUrl };
}

// =============================================================
//  Canvas white-background removal (fails open on CORS block)
// =============================================================
function removeWhiteFromImage(src, threshold) {
  if (threshold === undefined) threshold = 210;
  return new Promise(function (resolve) {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = function () {
      try {
        const canvas = document.createElement("canvas");
        canvas.width  = img.naturalWidth  || img.width;
        canvas.height = img.naturalHeight || img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const id    = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const px    = id.data;
        const range = 255 - threshold;
        for (let i = 0; i < px.length; i += 4) {
          const r = px[i], g = px[i + 1], b = px[i + 2];
          if (r >= threshold && g >= threshold && b >= threshold) {
            const whiteness = Math.min(r, g, b);
            px[i + 3] = range > 0
              ? Math.max(0, Math.round((255 - whiteness) * (255 / range)))
              : 0;
          }
        }
        ctx.putImageData(id, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      } catch (e) {
        resolve(null); // CORS or other error — caller falls back to original URL
      }
    };
    img.onerror = function () { resolve(null); };
    img.src = src;
  });
}

// =============================================================
//  Celebration — the big moment
// =============================================================
async function showEggCelebration(onDismiss, productImageUrl) {
  injectCelebrationStyles();

  // Strip white background via canvas — falls back gracefully if CDN blocks cross-origin reads
  let processedSrc = null;
  if (productImageUrl) processedSrc = await removeWhiteFromImage(productImageUrl);
  const bgRemoved = !!processedSrc;

  const overlay = document.createElement("div");
  overlay.id = "egg-celebration";
  overlay.style.cssText = [
    "position:fixed", "inset:0", "z-index:999999",
    "overflow:hidden", "cursor:pointer",
    "animation:egc-overlay-in 0.4s ease forwards",
    "background:linear-gradient(135deg,#0a0010,#1a0030,#0d0020,#100025)",
    "background-size:400% 400%",
    "animation:egc-overlay-in 0.4s ease forwards, egc-bg-pulse 4s ease infinite 0.4s",
  ].join(";");

  // ── Ambient spinning conic glow ────────────────────────────
  const ambientConic = document.createElement("div");
  ambientConic.style.cssText = [
    "position:absolute", "top:50%", "left:50%",
    "width:900px", "height:900px",
    "background:conic-gradient(from 0deg, rgba(255,80,150,0.18), rgba(255,200,0,0.22), rgba(80,255,180,0.15), rgba(120,80,255,0.2), rgba(255,80,150,0.18))",
    "border-radius:50%",
    "pointer-events:none",
    "animation:egc-ambient-spin 6s linear infinite",
  ].join(";");
  overlay.appendChild(ambientConic);

  // ── Centre radial glow ─────────────────────────────────────
  const centreGlow = document.createElement("div");
  centreGlow.style.cssText = [
    "position:absolute", "top:50%", "left:50%",
    "width:700px", "height:700px",
    "background:radial-gradient(circle, rgba(255,210,30,0.28) 0%, rgba(255,100,150,0.14) 40%, transparent 70%)",
    "border-radius:50%",
    "transform:translate(-50%,-50%)",
    "pointer-events:none",
  ].join(";");
  overlay.appendChild(centreGlow);

  // ── Pulsing rings (4 of them, staggered) ──────────────────
  [0, 0.5, 1.0, 1.5].forEach(delay => {
    const ring = document.createElement("div");
    const colors = ["rgba(255,215,0,0.7)", "rgba(255,100,180,0.6)", "rgba(100,220,255,0.55)", "rgba(180,255,120,0.5)"];
    ring.style.cssText = [
      "position:absolute", "top:50%", "left:50%",
      "width:260px", "height:260px",
      `border:2px solid ${colors[Math.round(delay * 2) % colors.length]}`,
      "border-radius:50%",
      "pointer-events:none",
      `animation:egc-ring 2s ${delay}s ease-out infinite`,
    ].join(";");
    overlay.appendChild(ring);
  });

  // ── Sparkle stars (12 of them) ────────────────────────────
  const sparklePositions = [
    {t:"18%",l:"22%"},{t:"14%",l:"55%"},{t:"20%",l:"78%"},
    {t:"50%",l:"10%"},{t:"50%",l:"88%"},
    {t:"78%",l:"18%"},{t:"82%",l:"50%"},{t:"76%",l:"80%"},
    {t:"35%",l:"18%"},{t:"30%",l:"82%"},{t:"65%",l:"12%"},{t:"62%",l:"86%"},
  ];
  const sparkleChars = ["✦","✧","⋆","✶","★","✸","✹"];
  const sparkleColors = ["#ffd700","#ff80c0","#80ffee","#c0ff80","#ff9900","#ff60a0","#60e0ff"];
  sparklePositions.forEach((pos, i) => {
    const el = document.createElement("div");
    el.textContent = sparkleChars[i % sparkleChars.length];
    el.style.cssText = [
      "position:absolute",
      `top:${pos.t}`, `left:${pos.l}`,
      `font-size:${14 + (i % 4) * 6}px`,
      `color:${sparkleColors[i % sparkleColors.length]}`,
      "pointer-events:none",
      `animation:egc-sparkle ${0.8 + (i % 4) * 0.3}s ${0.3 + i * 0.15}s ease forwards`,
    ].join(";");
    overlay.appendChild(el);
  });

  // ── Confetti rain (50 particles) ──────────────────────────
  const confettiColors = ["#ff4d8d","#ffd700","#4dffb8","#7b6dff","#ff7b4d","#4dddff","#ff4dff","#b8ff4d"];
  const confettiShapes = ["4px","50%","2px"]; // square, circle, thin bar
  for (let i = 0; i < 50; i++) {
    const piece = document.createElement("div");
    const size = 6 + Math.random() * 10;
    const shape = confettiShapes[Math.floor(Math.random() * confettiShapes.length)];
    piece.style.cssText = [
      "position:absolute",
      `top:-20px`,
      `left:${Math.random() * 100}%`,
      `width:${size}px`,
      `height:${shape === "2px" ? size * 2.5 : size}px`,
      `background:${confettiColors[Math.floor(Math.random() * confettiColors.length)]}`,
      `border-radius:${shape}`,
      "pointer-events:none",
      `animation:egc-confetti-fall ${1.8 + Math.random() * 2.5}s ${Math.random() * 1.8}s ease-in forwards`,
      `opacity:${0.7 + Math.random() * 0.3}`,
    ].join(";");
    overlay.appendChild(piece);
  }

  // ── Raining egg emojis (18 of them) ───────────────────────
  for (let i = 0; i < 18; i++) {
    const rainEgg = document.createElement("div");
    rainEgg.textContent = "🥚";
    rainEgg.style.cssText = [
      "position:absolute",
      "top:-50px",
      `left:${Math.random() * 100}%`,
      `font-size:${18 + Math.random() * 22}px`,
      "pointer-events:none",
      `animation:egc-rain-egg ${2.2 + Math.random() * 2.8}s ${Math.random() * 2.2}s ease-in forwards`,
    ].join(";");
    overlay.appendChild(rainEgg);
  }

  // ── Central egg image ──────────────────────────────────────
  const eggStage = document.createElement("div");
  eggStage.style.cssText = [
    "position:absolute", "top:50%", "left:50%",
    "transform:translate(-50%,-54%)",
    "display:flex", "flex-direction:column", "align-items:center", "gap:20px",
    "pointer-events:none", "text-align:center",
    "width:min(90vw,360px)",
  ].join(";");

  const eggImgWrap = document.createElement("div");
  eggImgWrap.style.cssText = [
    "width:160px", "height:160px",
    "border-radius:50%",
    "overflow:hidden",
    "display:flex", "align-items:center", "justify-content:center",
    bgRemoved ? "background:transparent" : "background:rgba(255,255,255,0.92)",
    "opacity:0",
    "animation:egc-egg-in 0.7s 0.3s cubic-bezier(0.175,0.885,0.32,1.275) forwards, egc-glow-pulse 1.8s 1s ease-in-out infinite",
  ].join(";");

  const eggImg = document.createElement("img");
  eggImg.src = bgRemoved ? processedSrc : (productImageUrl || GEAR_RECOMMENDATIONS.eggImageUrl);
  eggImg.alt = "Product image";
  eggImg.draggable = false;
  // scale(1.2) zooms the image inside the fixed container; overflow:hidden on the wrapper clips it
  eggImg.style.cssText = "width:130px;height:130px;object-fit:contain;display:block;transform:scale(1.2);";
  eggImgWrap.appendChild(eggImg);
  eggStage.appendChild(eggImgWrap);

  // Title
  const titleEl = document.createElement("div");
  titleEl.textContent = GEAR_RECOMMENDATIONS.text.celebrationTitle;
  titleEl.style.cssText = [
    "font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif",
    "font-size:clamp(28px,6.5vw,42px)",
    "font-weight:900",
    "color:#ffd700",
    "letter-spacing:0.02em",
    "line-height:1.1",
    "opacity:0",
    "animation:egc-title-in 0.5s 0.9s ease forwards, egc-title-glow 2s 1.4s ease-in-out infinite",
  ].join(";");
  eggStage.appendChild(titleEl);

  // Subtitle
  const subEl = document.createElement("div");
  subEl.textContent = GEAR_RECOMMENDATIONS.text.celebrationSubtitle;
  subEl.style.cssText = [
    "font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif",
    "font-size:clamp(13px,3.2vw,16px)",
    "font-weight:500",
    "color:rgba(255,255,255,0.82)",
    "line-height:1.45",
    "max-width:280px",
    "opacity:0",
    "animation:egc-sub-in 0.45s 1.3s ease forwards",
  ].join(";");
  eggStage.appendChild(subEl);

  overlay.appendChild(eggStage);

  // ── "Tap to continue" hint ─────────────────────────────────
  const hint = document.createElement("div");
  hint.textContent = GEAR_RECOMMENDATIONS.text.celebrationDismiss;
  hint.style.cssText = [
    "position:absolute", "bottom:36px", "left:50%",
    "transform:translateX(-50%)",
    "font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif",
    "font-size:15px", "font-weight:700",
    "color:#111", "letter-spacing:0.05em", "text-transform:uppercase",
    "background:#ffffff",
    "padding:10px 28px", "border-radius:999px",
    "white-space:nowrap", "pointer-events:none",
    "opacity:0",
    "animation:egc-sub-in 0.4s 1.9s ease forwards, egc-hint-pulse 1.6s 2.3s ease-in-out infinite",
  ].join(";");
  overlay.appendChild(hint);

  document.body.appendChild(overlay);

  // Dismiss on click or auto after 5.5s
  let dismissed = false;
  function dismiss() {
    if (dismissed) return;
    dismissed = true;
    overlay.style.transition = "opacity 0.4s ease";
    overlay.style.opacity = "0";
    setTimeout(() => { overlay.remove(); onDismiss(); }, 420);
  }

  overlay.addEventListener("click", dismiss);
  setTimeout(dismiss, 15000);
}

// =============================================================
//  Click handler
// =============================================================
async function handleEggClick(wrapper, egg) {
  // 1. Immediately remove interactivity
  wrapper.classList.add("popping");
  wrapper.style.pointerEvents = "none";
  setTimeout(() => wrapper.remove(), 380);

  // 2. Show celebration immediately — run cart add in parallel
  let cartResult = null;

  const cartPromise = (async () => {
    const { variantId } = await getProductData(egg.productHandle);
    if (!variantId) { cartResult = { success: false, soldOut: true }; return cartResult; }

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!res.ok) throw new Error("cart add failed");

      if (GEAR_RECOMMENDATIONS.rememberClicked) {
        localStorage.setItem("egg-clicked:" + egg.name, "1");
      }

      // Open the drawer immediately while celebration is still showing
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      document.dispatchEvent(new CustomEvent("cart:open"));

      cartResult = { success: true };
      return cartResult;
    } catch {
      cartResult = { success: false, soldOut: false };
      return cartResult;
    }
  })();

  showEggCelebration(async () => {
    const result = await cartPromise;
    if (result.success) {
      showToast(GEAR_RECOMMENDATIONS.text.toastSuccess);
    } else if (result.soldOut) {
      showToast(GEAR_RECOMMENDATIONS.text.toastSoldOut);
    } else {
      showToast(GEAR_RECOMMENDATIONS.text.toastError);
    }
  }, egg._imageUrl);
}

// =============================================================
//  Ended-today helper
// =============================================================
function getEndedEggsToday(now, hasPreviewAccess) {
  if (!hasPreviewAccess) return [];
  const todayStart = new Date(now);
  todayStart.setHours(0, 0, 0, 0);

  return GEAR_RECOMMENDATIONS.eggs.filter(egg => {
    // Hard-disabled or always-on eggs have no natural end time
    if (egg.activeOverride !== null && egg.activeOverride !== undefined) return false;
    if (!egg.timeframe) return false;

    const end = new Date(egg.timeframe.end);
    // End time has already passed AND it fell within today
    return now > end && end >= todayStart;
  });
}

// =============================================================
//  Announcement-bar updater
// =============================================================
function updateAnnouncementBar(activeEggs, endedEggsToday) {
  if (!GEAR_RECOMMENDATIONS.enableAnnouncementOverride) return;
  if (activeEggs.length === 0 && endedEggsToday.length === 0) return;

  const bar      = document.querySelector("[data-announcement-bar]");
  const carousel = document.querySelector("announcement-bar-carousel");
  if (!bar || !carousel) return;

  injectAnnouncementEasterStyles();

  const n = activeEggs.length;
  const easterPs = [];

  // One slide for all active eggs (count shown in the text template)
  if (n > 0) {
    const p = document.createElement("p");
    p.className = "prose heading is-selected";
    p.textContent = GEAR_RECOMMENDATIONS.text.announcementActive
      .replace("{count}", n)
      .replace("{s}", n > 1 ? "s" : "");
    easterPs.push(p);
  }

  endedEggsToday.forEach((egg, i) => {
    const p = document.createElement("p");
    p.className = "prose heading" + (n === 0 && i === 0 ? " is-selected" : "");
    p.innerHTML = `${GEAR_RECOMMENDATIONS.text.announcementEnded} <a href="${egg.placement.url}">${egg.placement.url}</a>`;
    easterPs.push(p);
  });

  if (easterPs.length === 0) return;

  // Apply Easter color scheme to the bar
  bar.classList.add("easter-announcement");

  // Deselect all existing carousel items
  carousel.querySelectorAll("p").forEach(p => p.classList.remove("is-selected"));

  // Prepend in reverse order so easterPs[0] ends up first
  for (let i = easterPs.length - 1; i >= 0; i--) {
    carousel.insertBefore(easterPs[i], carousel.firstChild);
  }
}

// =============================================================
//  Egg injector
// =============================================================
function injectEgg(egg) {
  const wrapper = document.createElement("div");
  wrapper.className = "easter-egg-wrapper";
  wrapper.style.top  = egg.placement.top;
  wrapper.style.left = egg.placement.left;
  wrapper.setAttribute("aria-label", GEAR_RECOMMENDATIONS.text.eggAriaLabel);
  wrapper.setAttribute("role", "button");
  wrapper.setAttribute("tabindex", "0");

  const img = document.createElement("img");
  img.src = GEAR_RECOMMENDATIONS.eggImageUrl;
  img.alt = "Easter egg";
  wrapper.appendChild(img);

  // Stay invisible until image loaded + browser has fully laid out and painted
  wrapper.style.opacity = "0";

  function revealWhenReady() {
    // Double rAF: first frame commits layout, second guarantees paint
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        wrapper.style.transition = "opacity 0.4s ease";
        wrapper.style.opacity = "1";
      });
    });
  }

  if (img.complete && img.naturalWidth > 0) {
    // Already cached — wait for layout/paint only
    document.body.appendChild(wrapper);
    revealWhenReady();
  } else {
    img.addEventListener("load",  revealWhenReady, { once: true });
    img.addEventListener("error", revealWhenReady, { once: true }); // show even if img fails
    document.body.appendChild(wrapper);
  }

  wrapper.addEventListener("click", () => handleEggClick(wrapper, egg));
  wrapper.addEventListener("keydown", (e) => {
    if (e.key === "Enter" || e.key === " ") handleEggClick(wrapper, egg);
  });
}

// =============================================================
//  Main — runs on DOMContentLoaded
// =============================================================
async function initEasterEggs() {
  injectStyles();

  const now        = new Date();
  const path       = window.location.pathname;
  const previewKey = GEAR_RECOMMENDATIONS.previewKey;

  // Preview gate — check localStorage instead of URL param
  const hasPreviewAccess = !previewKey || localStorage.getItem(previewKey) === "1";

  // Shared eligibility check (no URL filter yet)
  function baseEligible(egg) {
    if (egg.activeOverride === false) return false;
    if (egg.activeOverride !== true) {
      const start = new Date(egg.timeframe.start);
      const end   = new Date(egg.timeframe.end);
      if (now < start || now > end) return false;
    }
    if (!hasPreviewAccess) return false;
    if (GEAR_RECOMMENDATIONS.rememberClicked && localStorage.getItem("egg-clicked:" + egg.name) === "1") return false;
    return true;
  }

  // Site-wide active eggs (used for announcement bar count)
  const siteEligible = GEAR_RECOMMENDATIONS.eggs.filter(baseEligible);

  // Fetch product data once per unique egg (variantId for stock + imageUrl for celebration)
  const dataMap = new Map();
  for (const egg of siteEligible) {
    if (!dataMap.has(egg.name)) {
      dataMap.set(egg.name, await getProductData(egg.productHandle));
    }
  }

  // Inject eggs that are on this specific page and in stock; attach image for celebration
  for (const egg of siteEligible) {
    const data = dataMap.get(egg.name);
    if (egg.placement.url === path && data.variantId) {
      egg._imageUrl = data.imageUrl;
      injectEgg(egg);
    }
  }

  // Update announcement bar with all active (in-stock) eggs and any that ended today
  const activeEggs    = siteEligible.filter(egg => dataMap.get(egg.name)?.variantId);
  const endedToday    = getEndedEggsToday(now, hasPreviewAccess);
  updateAnnouncementBar(activeEggs, endedToday);
}

//if (document.readyState === "loading") {
//  document.addEventListener("DOMContentLoaded", initEasterEggs);
//} else {
//  initEasterEggs();
//}
